/* eslint-disable promise/prefer-await-to-callbacks */
import { PayloadAction } from '@reduxjs/toolkit';
import { combineEpics, Epic, ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { catchError, pluck, switchMap } from 'rxjs/operators';
import { dialogClose } from 'store/dialog/dialog.actions';
import { getProjects } from 'store/projects/projects.actions';
import { api } from 'utils/axiosInstance';
import { MassOperationRequest } from 'utils/restApplicationClient';
import { apiErrorHandler, notify } from '../../utils/handlers/notificationHandler';
import {
  getSimilarOperationIds,
  getSimilarOperationIdsError,
  getSimilarOperationIdsSuccess,
  performOperation,
  performOperationError,
  performOperationSuccess,
} from './jobs.actions';

const similarOperationIds: Epic = (action$) =>
  action$.pipe(
    ofType(getSimilarOperationIds),
    switchMap(({ payload }) => {
      return from(api.findJobsIdsByOperationType$POST$api_jobs_operationapplicablefor(payload)).pipe(
        switchMap((result) => {
          return of(getSimilarOperationIdsSuccess(result));
        }),
        catchError((error) => {
          apiErrorHandler(error);
          return of(getSimilarOperationIdsError());
        }),
      );
    }),
  );

const performOperationEpic: Epic = (action$) =>
  action$.pipe(
    ofType(performOperation.type),
    pluck<PayloadAction<MassOperationRequest>, 'payload'>('payload'),
    switchMap((payload) => {
      return from(api.performOperation(payload)).pipe(
        switchMap(() => {
          notify(`successmessage.massOperation.${payload.operation}`, 'success');
          return of(dialogClose(), performOperationSuccess(), getProjects());
        }),
        catchError((error) => {
          apiErrorHandler(error);
          return of(dialogClose(), performOperationError());
        }),
      );
    }),
  );

export const jobsEpics = combineEpics(similarOperationIds, performOperationEpic);
